import * as React from "react";
import { ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TrustAndDisclaimer() {
  return <section id="trust-disclaimer" className="py-16 md:py-24 bg-background">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
          <div className="inline-flex items-center justify-center p-3 mb-6 rounded-full bg-primary/10 text-primary">
            <ShieldCheck className="size-8" strokeWidth={1.5} />
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-foreground mb-6">
            Disclaimer & Transparency
          </h2>
          
          <div className="space-y-5 text-muted-foreground leading-relaxed text-sm md:text-base">
            <p>The information provided on this website is for general informational purposes only. While I strive to keep the information up to date and correct, I make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose.</p>
            <p>
              Any reliance you place on such information is therefore strictly at your own risk. In no event will I be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.
            </p>
            <p>Through this website, you may be able to link to other websites which are not under our control. I have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.</p>
          </div>

          <div className="mt-10">
            <Button variant="outline" size="lg" asChild>
              <Link to="/FAQPage">Read my FAQ</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}